import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { GqlService, listUnitsOfMeasureQuery } from '@shared/services/gql.service';
import { OverlayService } from '@shared/services/overlay.service';
import { SortUtils } from '@shared/utils/sort.utils';

@Injectable({
  providedIn: 'root',
})
export class ActivitiesTabService {
  private gqlService = inject(GqlService);
  private overlayService = inject(OverlayService);

  unitsOfMeasure = signal<listUnitsOfMeasureQuery[]>([]);

  async fetchUnitsOfMeasure(): Promise<void> {
    const { data, errors, success } = await firstValueFrom(this.gqlService.listUnitsOfMeasure$());

    if (data && success) {
      this.unitsOfMeasure.set(SortUtils.sortArrayByFieldGivenSpecialChars(data, 'name'));
    } else {
      this.overlayService.error(errors);
    }
  }

  updateList(value: string): void {
    this.unitsOfMeasure.set(
      SortUtils.sortArrayByFieldGivenSpecialChars(
        [...this.unitsOfMeasure(), { name: value } as listUnitsOfMeasureQuery],
        'name'
      )
    );
  }
}
